import { render } from "./AccordionMainElement.vue?vue&type=template&id=71c005ec&scoped=true&ts=true&lang=pug"
import script from "./AccordionMainElement.vue?vue&type=script&lang=ts"
export * from "./AccordionMainElement.vue?vue&type=script&lang=ts"

import "./AccordionMainElement.vue?vue&type=style&index=0&id=71c005ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c005ec"]])

export default __exports__